import React from 'react';
import { SimpleInput } from '../../../../../components/shared';

interface NecInputProps {
  onNecChange: (value: string) => void;
  necValue: string;
  isEnabled: boolean;
}

export const NecInput: React.FC<NecInputProps> = ({
  onNecChange,
  necValue,
  isEnabled
}) => {
  return (
    <SimpleInput
      title="NEC"
      label="Enter NEC details:"
      placeholder="Enter National Electrical Code information..."
      value={necValue}
      onChange={onNecChange}
      isEnabled={isEnabled}
    />
  );
};